import { NgModule } from '@angular/core';
import { SharedPrivateModule } from '@shared-private/shared-private.module';

import { AutoGuarantorModalComponent } from './components/auto-guarantor-modal/auto-guarantor-modal.component';

const MODULES = [SharedPrivateModule];
const COMPONENTS = [AutoGuarantorModalComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...COMPONENTS, ...MODULES]
})
export class SharedTenantModule {}
